(() => {
  if (window.productRecommendationsCarouselInitialized) return;

  window.productRecommendationsCarouselInitialized = true;

  const initializedSliders = new WeakSet();
  const observedRecommendations = new WeakSet();

  const getSlider = (component) => component.querySelector('[id^="Slider-"]');

  const syncControls = (component) => {
    const slider = getSlider(component);
    if (!slider) return;

    const isInfinite = Boolean(component.closest('.complementary-products'));
    const hasOverflow = slider.scrollWidth > slider.clientWidth + 1;
    component.classList.toggle('slider--no-buttons', !hasOverflow && !isInfinite);

    if (hasOverflow || isInfinite) {
      component.querySelectorAll('.slider-button').forEach((button) => {
        button.removeAttribute('disabled');
      });
    }
  };

  const onControlClick = (event) => {
    const button = event.target.closest('button[name="previous"], button[name="next"]');
    const component = button?.closest('.product-recommendations slider-component, .complementary-products slider-component');

    if (!button || !component) return;

    const slider = getSlider(component);
    if (!slider) return;

    const atStart = slider.scrollLeft <= 1;
    const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
    const isNext = button.name === 'next';

    if ((isNext && atEnd) || (!isNext && atStart)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      slider.scrollTo({
        left: isNext ? 0 : slider.scrollWidth - slider.clientWidth,
        behavior: 'smooth',
      });
    }
  };

  const initializeSlider = (component) => {
    if (initializedSliders.has(component)) {
      syncControls(component);
      return;
    }

    const slider = getSlider(component);
    if (!slider) return;

    initializedSliders.add(component);
    component.addEventListener('click', onControlClick, true);
    slider.addEventListener('scroll', () => syncControls(component), { passive: true });
    new ResizeObserver(() => syncControls(component)).observe(slider);
    new MutationObserver(() => syncControls(component)).observe(component, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      subtree: true,
    });
    syncControls(component);
  };

  const initializeRecommendations = (root) => {
    const component = root.querySelector('slider-component');
    if (component) initializeSlider(component);
  };

  const observeRecommendations = (root) => {
    if (observedRecommendations.has(root)) return;

    observedRecommendations.add(root);
    initializeRecommendations(root);
    new MutationObserver(() => initializeRecommendations(root)).observe(root, {
      childList: true,
      subtree: true,
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('.product-recommendations, .complementary-products').forEach(observeRecommendations);
  };

  initializeAll();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('.product-recommendations, .complementary-products')) {
      observeRecommendations(event.target);
    } else {
      initializeAll(event.target);
    }
  });
})();
